import 'katex/dist/katex.min.css'
import React from 'react'
import ReactDOM from 'react-dom/client'
import { AppProviders } from '../app/AppProviders'
import { App } from '../app/routes/App/App'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from '../app/config/queryClient'
import { initDatadog } from '../app/integrations/Datadog'
import { initSentry } from '../app/integrations/Sentry'
import './styles/tailwind.css'
import { ThemeProvider } from '@app/ThemeProvider'

// init datadog and Sentry only in production
const initializeServices = () => {
  if (import.meta.env.VITE_UI_ENV === 'production') {
    initDatadog()
    initSentry()
  }
}

const AppRoot = () => {
  React.useEffect(() => {
    initializeServices()
  }, [])

  // TODO: eliminate Providers with refactoring
  return (
    <React.StrictMode>
      <ThemeProvider>
        <QueryClientProvider client={queryClient}>
          <AppProviders>
            <App />
          </AppProviders>
        </QueryClientProvider>
      </ThemeProvider>
    </React.StrictMode>
  )
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(<AppRoot />)
